// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__24zZ6","amount":"Amount_amount__1DI6s","tip":"Amount_tip__IgmEU","tipHeader":"Amount_tipHeader__3EpL4","tipsWrap":"Amount_tipsWrap__MP4LD"};